"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseEvent = void 0;
function parseEvent(jsonString) {
    try {
        var obj = JSON.parse(jsonString);
        if (obj !== null) {
            var ret = new CustomEvent(obj.type, { detail: obj });
            console.debug('Parsed event:', ret);
            return ret;
        }
        else {
            console.warn('Unknown event type:', obj);
            return null;
        }
    }
    catch (error) {
        console.error('Failed to parse JSON:', error);
        return null;
    }
}
exports.parseEvent = parseEvent;
